module.exports = __webpack_public_path__ + "img/erroricon.55d0279b.svg";